import { API_BASE } from "../config/api";

async function fetchJsonOrThrow(url, options = {}) {
  const res = await fetch(url, options);
  if (res.ok) return res.json();

  let bodyText = "";
  try {
    bodyText = await res.text();
  } catch (e) {
    bodyText = "";
  }
  throw new Error(`Dashboard fetch failed (${res.status}): ${bodyText || res.statusText}`);
}

export async function fetchDashboardSection({ yearEnd, sub, include, query = {} }) {
  const search = new URLSearchParams();
  if (include) search.set("include", include);
  Object.entries(query).forEach(([key, value]) => {
    if (value == null) return;
    search.set(key, String(value));
  });

  const qs = search.toString();
  const url = `${API_BASE}/dashboard/${yearEnd}/${sub}${qs ? `?${qs}` : ""}`;
  return fetchJsonOrThrow(url);
}

export async function fetchDashboardComparison({ yearEnd, sub, query = {}, signal }) {
  const search = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value == null || value === "") return;
    search.set(key, String(value));
  });

  const qs = search.toString();
  const url = `${API_BASE}/dashboard-comparison/${yearEnd}/${sub}${qs ? `?${qs}` : ""}`;
  return fetchJsonOrThrow(url, { signal });
}

export async function fetchDashboardYearParts({ yearEnd, sub, topCustomersLimit = 80 }) {
  const [territoriesRes, topCustomersRes] = await Promise.all([
    fetchDashboardSection({
      yearEnd,
      sub,
      include: "territories",
      query: { breakdowns: true },
    }),
    fetchDashboardSection({
      yearEnd,
      sub,
      include: "topCustomers",
      query: { topCustomersLimit },
    }),
  ]);

  return {
    territories: territoriesRes.territories || [],
    topCustomers: topCustomersRes.topCustomers || [],
  };
}
